export default {
  dockingManagerApi: {
    getLedgerList: 'api/leledger/getList',
    getTDLogList: 'api/tdReceive/getLogs',
    rePushTool: 'api/tdReceive/rePushTool',
    rePushAll: 'api/tdReceive/rePushAll',
    getMSLogList: 'api/MSDockingApi/getLogList',
  }
}
